import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/client';
import { taskNavRef } from '../utils/taskNav';

/**
 * Каталог пробных тестов: список заготовок + старт своего списка для решения.
 */
export default function PracticeQuizzesPage() {
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [startingId, setStartingId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/tasks/practice-quizzes/');
        if (!cancelled) setQuizzes(Array.isArray(res.data) ? res.data : []);
      } catch {
        if (!cancelled) setError('Не удалось загрузить список тестов.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  async function startQuiz(quiz) {
    setStartingId(quiz.id);
    setError('');
    try {
      const res = await api.post(`/tasks/practice-quizzes/${quiz.id}/start/`);
      const listId = res.data?.list_id;
      const first = res.data?.first_task;
      const ref = taskNavRef(first);
      if (listId && ref) {
        navigate(`/work/${ref}?list=${listId}`);
        return;
      }
      setError('Тест создан, но не удалось открыть первую задачу.');
    } catch {
      setError('Не удалось начать тест.');
    } finally {
      setStartingId(null);
    }
  }

  return (
    <div className="practice-quizzes-page">
      <div className="catalog-page-header">
        <h1 className="catalog-page-title">Пробные тесты</h1>
        <p className="catalog-page-lead">
          Короткие проверки по темам. Кнопка «Решать» создаёт ваш список задач.
          В каталоге те же вопросы отмечены тегом «Тест» — можно фильтровать вместе с темой
          (например, «Циклы» + «Тест»).
        </p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <p className="text-secondary">Загрузка…</p>
      ) : quizzes.length === 0 ? (
        <p className="text-secondary">Пока нет опубликованных тестов.</p>
      ) : (
        <ul className="practice-quizzes-list">
          {quizzes.map((quiz) => (
            <li key={quiz.id} className="practice-quizzes-item">
              <div className="practice-quizzes-item-main">
                <h2 className="practice-quizzes-item-title">{quiz.title}</h2>
                <p className="practice-quizzes-item-meta text-secondary">
                  {quiz.task_count}{' '}
                  {quiz.task_count === 1
                    ? 'вопрос'
                    : quiz.task_count >= 2 && quiz.task_count <= 4
                      ? 'вопроса'
                      : 'вопросов'}
                  {quiz.topic_tags?.length
                    ? ` · ${quiz.topic_tags.map((t) => t.name).join(', ')}`
                    : ''}
                </p>
              </div>
              <div className="practice-quizzes-item-actions">
                {quiz.catalog_query ? (
                  <Link
                    to={`/catalog?${quiz.catalog_query}`}
                    className="btn btn-outline btn-sm"
                  >
                    В каталоге
                  </Link>
                ) : null}
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  disabled={startingId === quiz.id}
                  onClick={() => void startQuiz(quiz)}
                >
                  {startingId === quiz.id ? 'Открываю…' : 'Решать'}
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
